/* RESPONSIBLE TEAM: team-channels */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  collectionKey: 'sender_emails',
});
